import makeStyles from "@mui/styles/makeStyles";
import { theme } from "../../../App";

const imageSize = {
  height: 100,
  width: "100%",
  [theme.breakpoints.up("md")]: {
    height: 150,
  },
  [theme.breakpoints.down("md")]: {
    height: 120,
  },
  [theme.breakpoints.only("xs")]: {
    height: 70,
    width: 100,
  },
};

const useStyles = makeStyles({
  questionWrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
  },
  answer: {
    textAlign: "center",
    width: "100%",
  },
  choiceContainer: {
    display: "flex",
    flexDirection: "column",
    border: "1px solid #dadce0",
    borderRadius: 8,
    padding: 8,
    [theme.breakpoints.down("sm")]: {
      flexDirection: "row",
    },
  },
  imageContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    ...imageSize,
    position: "relative",
  },
  loader: {
    height: "45px",
    width: "45px",
    opacity: "0.7",
  },
  image: {
    ...imageSize,
    objectFit: "scale-down",
    borderRadius: 8,
  },
  checkbox: {
    position: "absolute",
    right: 0,
    top: 0,
    borderRadius: "50%",
    [theme.breakpoints.down("sm")]: {
      position: "relative",
      right: "unset",
      top: "unset",
      alignSelf: "flex-start",
      padding: 0,
    },
  },
  choiceText: {
    display: "flex",
    flex: 1,
    alignSelf: "flex-start",
    marginTop: 10,
    [theme.breakpoints.down("sm")]: {
      marginTop: 0,
      marginLeft: 10,
    },
  },
  viewWrapper: {
    display: "flex",
    justifyContent: "center",
    padding: "5px 0",
  },
  viewAllChoices: {
    minWidth: 100,
    height: 60,
    border: 0,
    outline: "none",
    fontSize: 12,
    background: "white",
    paddingRight: 0,
    paddingLeft: 5,
    color: "#6d6e71",
    alignItems: "center",
    textAlign: "left",
    justifyContent: "center",
    display: "flex",
    [theme.breakpoints.down("xs")]: {
      fontSize: 14,
    },
    "&:focus": {
      border: 0,
      outline: "none",
    },
  },
  sides: {
    display: "flex",
    width: "100%",
    borderBottom: "1px solid #6d6e71",
    marginBottom: "30px",
  },
});

export default useStyles;
